import { useRef } from "react";
import * as Scrivito from "scrivito";
import Slider from "react-slick";
import { isLiv } from "^/utils/isLiv";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

Scrivito.provideComponent("CarouselWidget", ({ widget }) => {
  const images = widget.get("images");

  if (!images.length) {
    return (
      <InPlaceEditingPlaceholder center>
        Select images in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  return (
    <div>
      <CarouselComponent images={images} />
    </div>
  );
});

function BaseCarousel({ images }) {
  const sliderRef = useRef(null);
  const bgColor = isLiv(Scrivito.currentPage()) ? "bg-teal" : "bg-blue";

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="carousel-content">
      <div className="carousel-images position-relative">
        <Slider ref={sliderRef} {...settings} className="carousel">
          {images.map((image, index) => (
            <div key={`${image.id()}${index}`}>
              <Scrivito.ImageTag
                content={image}
                alt={image.get("alternativeText")}
                className="carousel-item-img"
                loading="lazy"
                width={image?.metadata().get("width")}
                height={image?.metadata().get("height")}
              />
              {image.get("description") && (
                <div
                  className={`image-description p-2 ${bgColor}`}
                  dangerouslySetInnerHTML={{ __html: image.get("description") }}
                />
              )}
            </div>
          ))}
        </Slider>
        <button
          className="carousel-control-prev"
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
        </button>
        <button
          className="carousel-control-next"
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

const CarouselComponent = Scrivito.connect(BaseCarousel);
